import './spinner.css';
export default {
  "modifiers": {
    "inline": "pf-m-inline",
    "sm": "pf-m-sm",
    "md": "pf-m-md",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl"
  },
  "spinner": "pf-v5-c-spinner",
  "spinnerPath": "pf-v5-c-spinner__path"
};